import React from "react";
import InstitutionLogo from "./InstitutionLogo";

const TEAM_POINTS = { 1: 25, 2: 20, 3: 15, 5: 10, 7: 8, 8: 2 };
const MEDAL_EMOJI = { 1: "🥇", 2: "🥈", 3: "🥉" };

const LEGEND = [
  ["CP",     "Puntos de Clasificación acumulados"],
  ["VT",     "Victorias por toque / ausencia / lesión (5-0)"],
  ["ST",     "Victorias por superioridad (4-0 / 4-1)"],
  ["TP",     "Puntos Técnicos Obtenidos"],
  ["TP Gvn", "Puntos Técnicos Otorgados"],
];

const WrestlingRankingTable = ({ rows, title = "Clasificación Final" }) => {
  if (!rows?.length) return null;

  return (
    <div className="rounded-2xl border border-gray-200 overflow-hidden">
      <div className="px-5 py-2.5 flex items-center gap-3 bg-black/[0.03] border-b border-gray-200">
        <div className="w-0.5 h-5 rounded-full bg-blue-800 flex-shrink-0" />
        <span className="text-[0.82rem] font-bold text-gray-800">{title}</span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-black/[0.02] border-b border-gray-200">
              {["Lugar", "Luchador", "Universidad", "CP", "VT", "ST", "TP", "TP Gvn", "Pts Clasif."].map((h, i) => (
                <th
                  key={h}
                  className={`py-2.5 text-[0.65rem] font-bold uppercase tracking-wide text-gray-400
                    ${i === 0 ? "pl-5 pr-2 text-center w-14" : ""}
                    ${i === 1 ? "px-3 text-left" : ""}
                    ${i === 2 ? "px-3 text-left hidden sm:table-cell" : ""}
                    ${i >= 3 && i <= 7 ? "px-2 text-center w-12" : ""}
                    ${i === 8 ? "pr-5 pl-2 text-center w-24" : ""}
                  `}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, idx) => {
              const teamPts = r.place != null ? (TEAM_POINTS[r.place] ?? null) : null;
              const isTop3  = r.place <= 3;

              return (
                <tr key={r.registrationId ?? idx}
                  className="border-b border-gray-100 hover:bg-black/[0.02] transition-colors">
                  <td className="pl-5 pr-2 py-2.5 text-center">
                    {MEDAL_EMOJI[r.place] ? (
                      <span className="text-base leading-none">{MEDAL_EMOJI[r.place]}</span>
                    ) : (
                      <span className="text-[0.78rem] font-bold text-gray-500">{r.place ?? "—"}</span>
                    )}
                  </td>
                  <td className="px-3 py-2.5">
                    <div className="flex items-center gap-2">
                      <InstitutionLogo logoUrl={r.logoUrl} name={r.inst} size={22} showTooltip={!!r.inst} />
                      <span className={`text-[0.82rem] ${isTop3 ? "font-bold text-gray-900" : "font-medium text-gray-800"}`}>
                        {r.wrestler}
                      </span>
                    </div>
                  </td>
                  <td className="px-3 py-2.5 hidden sm:table-cell">
                    <span className="text-[0.72rem] text-gray-400">{r.inst}</span>
                  </td>
                  <td className="px-2 py-2.5 text-center font-bold text-gray-900 tabular-nums">{r.cp}</td>
                  <td className="px-2 py-2.5 text-center text-gray-600 tabular-nums">{r.vt}</td>
                  <td className="px-2 py-2.5 text-center text-gray-600 tabular-nums">{r.st}</td>
                  <td className="px-2 py-2.5 text-center text-gray-600 tabular-nums">{r.tp}</td>
                  <td className="px-2 py-2.5 text-center text-gray-600 tabular-nums">{r.tpGvn}</td>
                  <td className="pr-5 pl-2 py-2.5 text-center font-extrabold text-gray-900 tabular-nums">
                    {teamPts != null ? teamPts : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="px-5 py-3 bg-black/[0.02] border-t border-gray-200 flex flex-wrap gap-x-5 gap-y-1">
        {LEGEND.map(([k, v]) => (
          <span key={k} className="text-[0.62rem] text-gray-400">
            <strong className="text-gray-500">{k}</strong>: {v}
          </span>
        ))}
      </div>
    </div>
  );
};

export default WrestlingRankingTable;